function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_22",
  "data-name": "Group 22",
  transform: "translate(506.904 -1246.719)"
}, React.createElement("rect", {
  id: "Rectangle_9",
  "data-name": "Rectangle 9",
  width: 64.468,
  height: 10.761,
  transform: "translate(-506.904 1246.719)"
}), React.createElement("rect", {
  id: "Rectangle_10",
  "data-name": "Rectangle 10",
  width: 38.41,
  height: 10.761,
  transform: "translate(-493.874 1264.564)"
}), React.createElement("rect", {
  id: "Rectangle_11",
  "data-name": "Rectangle 11",
  width: 15.375,
  height: 10.761,
  transform: "translate(-482.357 1282.41)"
}));

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 64.468,
    height: 46.453,
    viewBox: "0 0 64.468 46.453",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.190f5db0.svg";
export { ForwardRef as ReactComponent };